// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"651":"3cf8a110d522d2b6","702":"06f0ec896669f437"}[chunkId] + ".js";
};